import type {
    Company,
    LocationIP,
    User,
} from '../types/domain'

export const SUPER_ADMIN_SET_USERS = 'SUPER_ADMIN_SET_USERS'
export const SUPER_ADMIN_SET_COMPANIES = 'SUPER_ADMIN_SET_COMPANIES'
export const SUPER_ADMIN_SET_LOCATIONS_IP = 'SUPER_ADMIN_SET_LOCATIONS_IP'

export interface SuperAdminState {
    users: User[]
    companies: Company[]
    locationsIP: LocationIP[]
}

interface SetUsersAction {
    type: typeof SUPER_ADMIN_SET_USERS
    users: User[]
}

interface SetCompaniesAction {
    type: typeof SUPER_ADMIN_SET_COMPANIES
    companies: Company[]
}

interface SetLocationsIPAction {
    type: typeof SUPER_ADMIN_SET_LOCATIONS_IP
    locationsIP: LocationIP[]
}

type SuperAdminAction = SetUsersAction | SetCompaniesAction | SetLocationsIPAction

/**
 * Set users into store
 */
function setUsers(state: SuperAdminState, users: User[]): SuperAdminState {
    return {
        ...state,
        users: users,
    }
}

/**
 * Set companies into store
 */
function setCompanies(state: SuperAdminState, companies: Company[]): SuperAdminState {
    return {
        ...state,
        companies: companies,
    }
}

/**
 * Set locations ip into store
 */
function setLocationsIp(state: SuperAdminState, locationsIP: LocationIP[]): SuperAdminState {
    return {
        ...state,
        locationsIP: locationsIP,
    }
}

/**
 * Reducer for super admin in store
 */
export default function reducer(
    state: SuperAdminState = [] as unknown as SuperAdminState,
    action: SuperAdminAction,
): SuperAdminState {
    switch (action.type) {
        case SUPER_ADMIN_SET_USERS: return setUsers(state, action.users)
        case SUPER_ADMIN_SET_COMPANIES: return setCompanies(state, action.companies)
        case SUPER_ADMIN_SET_LOCATIONS_IP: return setLocationsIp(state, action.locationsIP)
        default: return state
    }
}
